import { CIcon } from '~/icons/types'
export const ciAudit: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.336 3.169a32.31 32.31 0 0 0-.673-.051A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618 44.88 44.88 0 0 0-.673.051A2.924 2.924 0 0 0 7.5 6h7.13A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108a2.927 2.927 0 0 0-2.664-2.939ZM12 4.5A1.5 1.5 0 0 1 13.5 3H15a1.5 1.5 0 0 1 1.5 1.5H12Z'
    },
    {
      d:
        'M14.625 7.5h-9.75A1.874 1.874 0 0 0 3 9.375v11.25A1.875 1.875 0 0 0 4.875 22.5h9.75a1.875 1.875 0 0 0 1.875-1.875V9.375A1.874 1.874 0 0 0 14.625 7.5Zm-1.989 5.9-2.5 4a.753.753 0 0 1-.592.352H9.5a.752.752 0 0 1-.586-.281l-2-2.5a.751.751 0 1 1 1.172-.938l1.339 1.674 1.939-3.1a.752.752 0 0 1 1.26-.052.751.751 0 0 1 .012.846V13.4Z'
    }
  ],
  name: 'audit',
  type: 'solid'
}
